// Caja para seleccionar cliente 

import { useEffect, useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { apiFetchJson } from '../fetchWrapper';

export default function ClientSelector({ onSelectClientId }) {

  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetchJson("/api/clients").then(setClients)
      .catch((err) => setError(err.message));
  }, []);

  const handleChange = (e) => {
    const clientId = e.target.value ? Number(e.target.value) : null;
    setSelectedClientId(clientId);
    onSelectClientId(clientId);
  };

  return (
    <FormControl fullWidth sx={{ mb: 1}}>
      <InputLabel id="client-select-label">Seleccione un cliente</InputLabel>
      <Select
        labelId="client-select-label"
        value={selectedClientId}
        label="Seleccione un cliente"
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>-- Clientes --</em>
        </MenuItem>
        {clients.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {client.companyName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}